<template>
  <v-alert
    v-model="show"
    v-if="show"
    style="
      background-color: #2d3a5e;
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      max-width: 800px;
      min-width: 600px;
      padding: 20px;
    "
    class="alert-notify version-update-alert text-h6"
    color="#fdb813"
    border="left"
    elevation="6"
    colored-border
    dismissible
    @input="dismiss"
  >
    <v-row align="center" no-gutters>
      <v-col class="grow">
        <v-icon left color="#fdb813">mdi-update</v-icon>
        <span class="white--text">{{ $t("version-update-available") }}</span>
      </v-col>
      <v-col class="shrink">
        <v-btn
          text
          small
          @click="reloadPage"
          class="ml-2"
          style="color: #fdb813"
        >
          {{ $t("reload") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { EventBus } from "@/plugins/bus";

export default {
  name: "VersionUpdateNotification",
  data() {
    return {
      show: false,
      notificationData: null,
    };
  },
  mounted() {
    EventBus.$on("show-version-update-notification", this.showNotification);
  },
  beforeDestroy() {
    EventBus.$off("show-version-update-notification", this.showNotification);
  },
  methods: {
    showNotification(data) {
      this.notificationData = data;
      this.show = true;
    },
    reloadPage() {
      window.location.reload();
    },
    dismiss() {
      this.show = false;
      this.notificationData = null;
    },
  },
};
</script>

<style scoped>
.version-update-alert {
  z-index: 999999 !important;
}
</style>
